import {useCallback, useState, FC, useEffect, useMemo} from 'react';
//Selectors
import {updateCurrentRoom} from '@stencil/hotels-cg-reducer/src/details/actions';
import {
  coupleFriendlySelector,
  goTribeBenefitsSelector,
  hotelDetailsSelector,
  isGoStaysSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';

import {
  isAltAccoSelector,
  staticApiRequestSelector,
  multiRoomFlowStatusSelector,
  roomsDataSelector,
  searchRoomApiRequestSelector,
  streaksBannerSelector,
  previousBookingDataSelector,
  recommendedCombosSelector,
  hotelPersuasionsDetailsSelector,
  templateDataSelector,
  isAltAccoUrlPropsSelector,
  hotelCardDataDetailsSelector,
  hotelDetailsSoldOut,
} from '@stencil/hotels-cg-reducer/src/details/selectors';

// UTILS
import calculateCgRoomPriceData from '@stencil/hotels-utils/src/details-calculate-cg-room-price-data';

// HOOKS
import {useDispatch, useSelector} from 'react-redux';
import WhatOurGuestLikeLoader from '../../../../../stories/components/hotels/Loadingpage/WhatOurGuestLikeLoader/WhatOurGuestLikeLoader';
import useQuery from '@stencil/use-query';

import * as S from './styles/PriceNBookingButtonNPersuasion.styles';
import GoTribeDetailUI from '../../../../../stories/components/hotels/DetailsPageUnif/GoTribeDetailUI/GoTribeDetailUI';
import {RightWidgetLoader} from '../../../../../stories/components/hotels/Loadingpage/DetailCardLoader/DetailCardLoader';
import GoStreakDetails from '../../../../../stories/components/hotels/DetailsPageUnif/GoStreakDetails/GoStreakDetails';
import GoTribeBenefits from '@stencil/gi-components/src/GoTribe/GoTribeBenefits/GoTribeBenefits';

import LOSCard from './LOSCard/LOSCard';
import DealsDiscoveryWidget from './DealsDiscoveryWidget';
import AlternateDates from '../AlternateDates/AlternateDates';
import SoldoutCardLoading from '../AlternateDates/SoldoutCardLoading';
import AlternateDatesCardLoading from '../AlternateDates/AlternateDatesCardLoading';
import {
  getBankDealsData,
  getComboFilteredRooms,
  getPriceInfo,
  isBot,
  isValidArray,
} from '@stencil/hotels-utils/src/common-utils';
import useIsClient from '@stencil/hotels-hooks/src/useIsClient';
import {commonSelectorFn} from '@stencil/hotels-common-reducer/src/selectors';
import MultiRoomQuickBook from '../RoomSelection/MultiRoom/MultiRoomQuickBook/MultiRoomQuickBook';
import NoworNeverDealSRPCg from '@stencil/noworneverdealtimer/src/noworneverdealtimercg';
import DetailQuickBookandBookingWidgetWrapper from './PreviousBookingQuickBook';
import {isObjectEmpty} from '@stencil/hotels-utils/src/common-utils';
import {getSlashAndShowPriceCg} from '@stencil/hotels-utils/src/get-details-slash-and-show-price';
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';
import SalesCampaignUI from '@stencil/gi-components/src/SalesCampaignUI/SalesCampaignUI';
import PackageFeatureCardContainer from '../PackageFeatureCardContainer/PackageFeatureCardContainer';
import {scrollIntoViewDetails} from '@stencil/hotels-utils/src/scroll-into-view-details';
import {detailsNavigationIdsAndValues} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import SoldOutCheckAvailability from '../../../../../stories/components/hotels/DetailsPageUnif/SoldOutCheckAvailability';

const saleHandlingCustomStyle = {
  Image: {width: '6.6rem', height: '5.6rem'},
  Wrapper: {margin: '1rem 0rem'},
  Header: {marginBottom: '0.5rem'},
};

interface PriceNBookingButtonNPersuasionProps {
  isSeo?: boolean;
  onPromoChange?: () => {};
  handlOpenCalendar: () => {};
}

const PriceNBookingButtonNPersuasion: FC<PriceNBookingButtonNPersuasionProps> = ({
  isSeo,
  handlOpenCalendar = () => {},
}) => {
  const [activeBankCode, setActiveBankCode] = useState();
  const [priceInfo, setPriceInfo] = useState(null);
  const isClient = useIsClient();

  const dispatch = useDispatch();

  const isGostay = useSelector(isGoStaysSelector);
  const coupleFriendlyData = useSelector(coupleFriendlySelector);
  const isAltAcoo = useSelector(isAltAccoSelector);
  const staticApiRequest = useSelector(staticApiRequestSelector);
  const hotelDetails = useSelector(hotelDetailsSelector);
  const searchRoomApiRequest = useSelector(searchRoomApiRequestSelector);
  const roomsDataFromCg = useSelector(roomsDataSelector);
  const isAltAccoUrlProps = useSelector(isAltAccoUrlPropsSelector);
  const hotelCardDataDetails = useSelector(hotelCardDataDetailsSelector);
  const multiRoomFlowStatus = useSelector(multiRoomFlowStatusSelector);
  const isSoldOut = useSelector(hotelDetailsSoldOut);

  const {isDatePickRequired, isRedirectTOSRPRequired} = useSelector(commonSelectorFn);
  const previousBookingRoomData = useSelector(previousBookingDataSelector);
  const hotelLevelPersuasion = useSelector(hotelPersuasionsDetailsSelector);
  const streaksInfo = useSelector(streaksBannerSelector);
  const templateData = useSelector(templateDataSelector);
  const gotribebenefits = useSelector(goTribeBenefitsSelector);

  const isMultiRoom = multiRoomFlowStatus?.isMultiRoomFlow;
  const isRecommendedCombo = multiRoomFlowStatus?.hasRecommendedCombos;

  const LOSData = useMemo(
    () =>
      (isValidArray(hotelCardDataDetails) &&
        hotelCardDataDetails?.find(item => item?.cardInfo?.id === 'LONG_STAY_BENEFITS')) ||
      {},
    [hotelCardDataDetails],
  );

  const isSingleRoomWithSingleRatePlan =
    roomsDataFromCg?.length == 1 && roomsDataFromCg?.[0]?.ratePlans?.length == 1;
  const filteredRooms = roomsDataFromCg;

  const rooms = filteredRooms;

  const {getQueryParam} = useQuery();
  const hQuery = useMemo(() => {
    try {
      const queryParam = getQueryParam('hquery');
      if (queryParam) {
        return JSON.parse(queryParam as string);
      }
    } catch (error) {
      console.error('Failed to parse hquery:', error);
    }
    return {};
  }, [getQueryParam('hquery')]);

  const memoisedcalculateCgRoomPriceData = useCallback(calculateCgRoomPriceData, [
    hQuery,
    roomsDataFromCg,
    activeBankCode,
  ]);

  const currentRoomData = memoisedcalculateCgRoomPriceData({
    hQuery,
    roomsDataFromCg: rooms,
    activeBankCode,
    isMultiRoom,
  });

  // fires on first mount and anytime another room is selected
  useEffect(() => {
    dispatch(updateCurrentRoom(currentRoomData));
  }, [currentRoomData.roomPrice, activeBankCode]);

  const isBotAgent = __CLIENT__ ? isBot(window?.navigator?.userAgent) : false;
  const isAltAco = useSelector(isAltAccoSelector);
  const comboListFromCg = useSelector(recommendedCombosSelector);

  const saleCampaignUIData =
    !isObjectEmpty(templateData?.SALE_CAMPAIGN) && templateData?.SALE_CAMPAIGN;

  const getComboList = () => {
    let copyComboList = [];
    if (comboListFromCg) {
      copyComboList = JSON.parse(JSON.stringify(comboListFromCg));
      copyComboList.map(element => {
        let filteredRooms = getComboFilteredRooms(element);
        element.rooms = filteredRooms;
      });
    }

    return copyComboList;
  };

  const getMinimumPriceCombo = () => {
    const comboList = getComboList();
    let mimimumComboData = comboList[0];
    const {showPrice: miniumShowPrice} = getSlashAndShowPriceCg(
      mimimumComboData?.comboTariff,
      activeBankCode,
    );
    comboList.forEach(element => {
      const {showPrice} = getSlashAndShowPriceCg(element?.comboTariff, activeBankCode);

      if (showPrice < miniumShowPrice) {
        mimimumComboData = element;
      }
    });
    return {
      tariff: mimimumComboData?.comboTariff,
      tariffPersuasion: mimimumComboData?.comboOfferPersuasions,
    };
  };

  const promoChangeHandler = code => {
    setActiveBankCode(code);
    const info = getPriceInfo(
      isRecommendedCombo ? getMinimumPriceCombo()?.tariff : currentRoomData?.tariff?.[0],
      code,
    );
    setPriceInfo(info);
  };

  const onBankModalOpenHandler = () => {
    const info = getPriceInfo(
      isRecommendedCombo ? getMinimumPriceCombo()?.tariff : currentRoomData?.tariff?.[0],
      activeBankCode,
    );
    setPriceInfo(info);
  };

  const handlePackageClick = () => {
    scrollIntoViewDetails(
      document.querySelector(
        isAltAco ? detailsNavigationIdsAndValues.stays.id : detailsNavigationIdsAndValues.rooms.id,
      ),
    );
    dispatch(
      omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
        cta: {
          name: detailsClick.elitePackage.elitePackageClicked,
          type: omnitureConfig.ctaType.Card,
          componentName: DetailsPageComponents.ElitePackages,
          destination: '',
        },
      }),
    );
  };

  const {
    bankDealData: bankDealsData,
    bankPromoCount,
    firstBankDealData,
  } = getBankDealsData(
    isRecommendedCombo ? getMinimumPriceCombo()?.tariff : currentRoomData?.tariff?.[0],
    activeBankCode,
  );

  /**
   * the loader is already taken care of in 'HotelDetails' component
   * (it's a clubbed loader, so using it only at one place)
   */
  if (staticApiRequest?.loading) return null;

  const renderSoldoutUI = () => {
    if (isDatePickRequired || isRedirectTOSRPRequired) {
      return <SoldOutCheckAvailability handlOpenCalendar={handlOpenCalendar} />;
    }
    if (!isClient) {
      return (
        <>
          <SoldoutCardLoading />
          <AlternateDatesCardLoading />
        </>
      );
    } else {
      return <AlternateDates />;
    }
  };

  const roomTypeRenderer = () => {
    const Component = (
      <DetailQuickBookandBookingWidgetWrapper
        isSingleRoomWithSingleRatePlan={isSingleRoomWithSingleRatePlan}
        showPersuasion={
          !isMultiRoom &&
          !previousBookingRoomData?.length &&
          !isSingleRoomWithSingleRatePlan &&
          !!(hotelLevelPersuasion?.bestOffersSection?.length > 1)
        }
        hotelLevelPersuasion={hotelLevelPersuasion}
        handlOpenCalendar={handlOpenCalendar}
        altAcco={isAltAccoUrlProps}
        isDatePickRequired={isDatePickRequired}
      />
    );

    if (!searchRoomApiRequest?.success) {
      return <WhatOurGuestLikeLoader />;
    } else if (isRecommendedCombo) {
      return (
        <MultiRoomQuickBook
          activeBankCode={activeBankCode}
          isAltAccount={isAltAccoUrlProps}
          handlOpenCalendar={handlOpenCalendar}
        />
      );
    }
    // else if (pokusDataStatus === FetchStatusType.RESOLVED && pokusExpData?.quickBook) {
    //   return null;
    // } // TODO: update it if needed
    else return Component;
  };

  const marginTop =
    isGostay || hotelDetails?.starRating || coupleFriendlyData ? '4.5rem' : '1.5rem';

  const renderPriceAndPerusasionsComponent = () => {
    return (
      <S.UGCPersuasionsAndBookingWidget width={'360px'} marginTop={marginTop} isAltAcoo={isAltAcoo}>
        {searchRoomApiRequest?.loading ? (
          <RightWidgetLoader />
        ) : (
          <S.SignUpPersuasionEMIBookingWidgetContainer width={'360px'}>
            {!isObjectEmpty(streaksInfo) &&
              streaksInfo?.is_gostreaks_active &&
              streaksInfo?.page_details?.hotel_details?.show_tracker && (
                <GoStreakDetails streaksInfo={streaksInfo} />
              )}
            {/* Now or Never Deal Persusaion Starts */}
            {!previousBookingRoomData?.length &&
            !isSingleRoomWithSingleRatePlan &&
            hotelLevelPersuasion?.deals &&
            hotelLevelPersuasion?.deals.length > 0 ? (
              <div>
                <NoworNeverDealSRPCg
                  isRowAligned={true}
                  persuasiondata={hotelLevelPersuasion?.deals}
                  isSeo={isSeo}
                />
              </div>
            ) : null}
            {/* Now or Never Deal Persusaion Ends */}
            {/* Pricing Component Starts */}
            {roomTypeRenderer()}
            {/* Pricing Component Ends */}

            {/* ElitPackages Persuasion Starts */}
            <PackageFeatureCardContainer handlePackageClick={handlePackageClick} />
            {/* ElitPackages Persuasion Ends */}

            {!!(hotelLevelPersuasion?.goTribeBenefits?.length > 0) &&
              !previousBookingRoomData?.length &&
              !isSingleRoomWithSingleRatePlan && (
                <div>
                  <GoTribeDetailUI persuationData={hotelLevelPersuasion?.goTribeBenefits} />
                </div>
              )}
            {/* SALESHANDLING */}
            {saleCampaignUIData && (
              <SalesCampaignUI
                customStyles={saleHandlingCustomStyle}
                campaignData={saleCampaignUIData}
              />
            )}
            {/* goTribe */}
            {isValidArray(gotribebenefits?.benefits) && (
              <GoTribeBenefits goTribeBenefits={gotribebenefits} />
            )}
            {isObjectEmpty(LOSData?.cardInfo) ? (
              <DealsDiscoveryWidget
                bankDealsData={bankDealsData}
                bankPromoCount={bankPromoCount}
                priceInfo={priceInfo}
                firstBankDealData={firstBankDealData}
                activeBankCode={activeBankCode}
                offersPersuasions={
                  isRecommendedCombo
                    ? getMinimumPriceCombo()?.tariffPersuasion
                    : currentRoomData?.tariffPersuasion
                }
                onPromoChange={promoChangeHandler}
                onModalOpen={onBankModalOpenHandler}
              />
            ) : (
              <LOSCard data={LOSData?.cardInfo} />
            )}
          </S.SignUpPersuasionEMIBookingWidgetContainer>
        )}
      </S.UGCPersuasionsAndBookingWidget>
    );
  };

  return (
    <S.OuterWrapperDiv>
      <S.Container minWidth={isSoldOut && '120%'} margin={isSoldOut && marginTop}>
        {isSoldOut ? renderSoldoutUI() : renderPriceAndPerusasionsComponent()}
      </S.Container>
    </S.OuterWrapperDiv>
  );
};

export default PriceNBookingButtonNPersuasion;
